import { api } from './api'

export const fetchWallet = (query) => api.get('/wallet', query)
export const addWallet = (wallet) => api.post('/wallet', wallet)
export const fetchWalletByCustomerId = (customerId) => api.get(`/customer/${customerId}/wallet`)
